import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, Chip } from "@mui/material";
import { OverflowTooltip, Table } from "@4uhub/lib4uhub";
import MainApi from "../../../../../../services/mainApi.service";
import { useCallback, useMemo, useState } from "react";
import { ITicketAutomationReceivedRuleInsuranceCategory } from "../../../../../../models/ticket-automation-received-rule-insurance-category";
import InsuranceCategory from "./InsuranceCategoryForm/InsuranceCategory";

const TICKET_AUTOMATION_RECEIVED_RULES_ROUTE =
  process.env.REACT_APP_AUTOMATIONS +
  "/api/v1/TicketAutomationReceivedRuleInsuranceCategory/";
const ticketAutomationReceivedRulesService =
  new MainApi<ITicketAutomationReceivedRuleInsuranceCategory>(
    TICKET_AUTOMATION_RECEIVED_RULES_ROUTE,
  );

const translationPath =
  "chatBot.page.automations.automationReceivedRules.automationReceivedRuleInsuranceCategory.";

const InsuranceCategoryPage = () => {
  const { t } = useTranslation();

  const { id: ticketAutomationReceivedRuleId } = useParams();

  const [timeRuleForm, setTimeRuleForm] = useState(false);

  const [selectedId, setSelectedId] = useState<string>();

  const columns: GridColDef<ITicketAutomationReceivedRuleInsuranceCategory>[] =
    [
      {
        field: "insuranceExternalId",
        headerName:
          t(translationPath + "insuranceExternalId") || "Insurance External ID",
      },
      {
        field: "insuranceExternalName",
        headerName:
          t(translationPath + "insuranceExternalName") ||
          "Insurance External Name",
        renderCell: (params) =>
          params.value ? (
            <OverflowTooltip
              text={params.value}
              tooltip={params.value}
              textTransform="none"
              variant="body2"
            />
          ) : (
            "-"
          ),
      },
      {
        field: "enable",
        headerName: t(translationPath + "status") || "Status",
        maxWidth: 120,
        renderCell: (params) => (
          <Chip
            size="small"
            label={
              params.value
                ? t(translationPath + "active")
                : t(translationPath + "inactive")
            }
            color={params.value ? "success" : "error"}
          />
        ),
      },
    ];

  const handleAdd = () => {
    setTimeRuleForm(true);
  };

  const handleRowClick = (
    params: GridRowParams<ITicketAutomationReceivedRuleInsuranceCategory>,
  ) => {
    if (!params.row) return;
    setTimeRuleForm(true);
    setSelectedId(params.row.id);
  };

  const handleBack = useCallback(() => {
    setSelectedId(undefined);
    setTimeRuleForm(false);
  }, []);
  const props = useMemo(() => {
    return {
      TicketAutomationReceivedRuleId: ticketAutomationReceivedRuleId,
    };
  }, [ticketAutomationReceivedRuleId]);

  return (
    <Box sx={{ height: 600, width: "100%" }}>
      {timeRuleForm && (
        <Box
          sx={(t) => ({
            p: 1,
            px: 10,
            width: "100%",
            height: "100%",
            overflow: "auto",
            backgroundColor: t.palette.background.default,
            borderRadius: 1,
          })}
        >
          <InsuranceCategory
            id={selectedId}
            ticketAutomationReceivedRuleId={ticketAutomationReceivedRuleId}
            onBackButton={handleBack}
          />
        </Box>
      )}
      {!timeRuleForm && (
        <Box height={600}>
          <Table<ITicketAutomationReceivedRuleInsuranceCategory>
            showDefaultMacroFilters={false}
            service={ticketAutomationReceivedRulesService}
            columns={columns}
            title={""}
            searchInput
            onAdd={handleAdd}
            onRowClick={handleRowClick}
            searchInputAutoFocus={false}
            defaultPageSize={20}
            serviceProps={props}
            pageSizeOptions={[5, 10, 20]}
            searchInputPlaceHolder={""}
            addButtonLabel={
              t(translationPath + "add_insurance") ||
              "Add Automation Tasy Orientation"
            }
            confirmOptions={{
              title: t(translationPath + "confirm.title"),
              description: t(translationPath + "confirm.description"),
              confirmationButtonProps: {
                variant: "contained",
              },
            }}
          />
        </Box>
      )}
    </Box>
  );
};

export default InsuranceCategoryPage;
